<div class="dropdown-wrapper" [ngClass]="dropDownConfig?.wrapClass">
  <mat-form-field class="input-field" [appearance]="dropDownConfig?.inputAppearance">
    <mat-label>{{dropDownConfig?.selectPlaceHolder}}</mat-label>
    <mat-select [placeholder]="dropDownConfig?.selectPlaceHolder" (openedChange)="resetSearch()" (selectionChange)="dataEmit.emit(dropDownConfig.selectedOption)" [(ngModel)]="dropDownConfig.selectedOption">
      <app-input class="search-input" inputType="text" [control]="searchText" [group]="searchForm" placeHolder="Search" (OnChange)="search($event)"></app-input>
      <mat-option *ngFor="let item of (filteredList | keyvalue)" [value]="item?.key">
        {{item?.value}}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>